import React, { useEffect } from 'react'
import './Article.scss'
import Footer from '../Footer/Footer'
import { VignetteArticle } from 'react-vignette';
import { Waves } from "../../Services/Flakes";
import { Waves as waves2 } from "../../Services/Flakes2";
import { Waves as waves3 } from "../../Services/Flakes3";
import { mobile } from "../../Services/Agent";
import { GA_VPush } from '../../Services/GoogleAnalytics';
import "../../Services/domChangedEvent";

export default function Article(props) {
  // The prop id
  let id = (props.match.url).slice(1, props.match.url.length)
  let height = document.body.clientHeight;

  useEffect(() => {
    document.body.style.overflowY = "scroll"
    document.body.style.overflowX = "hidden"
    //document.body.style.overflow = "scroll"

    // Analitics - Virtual page push
    // setTimeout(()=> {
    //   GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/article/" + id , document.querySelector("#artiheader h1").textContent)
    //   // console.log(`/reality-check/article/${id}` , document.querySelector("#artiheader h1").textContent)
    // } , 1500)
  }, [])

  // Canvas inisialize
  useEffect(() => {
    try {
      let mywaves = new Waves({
        divId: "waves",
        numberOfNodes: 200,
        dotNumber: mobile() ? 30 : 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      console.error(err.message);
    }
    try {
      let mywaves = new waves2({
        divId: "waves2",
        numberOfNodes: 200,
        dotNumber: mobile() ? 30 : 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      console.error(err.message);
    }
    try {
      let mywaves = new waves3({
        divId: "waves3",
        numberOfNodes: 200,
        dotNumber: mobile() ? 30 : 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }
  }, []);

  useEffect(() => {
    window.onDomChange(() => {
      if (window.document.querySelector("#artiheader h1")) {
        if (window.document.querySelector("#artiheader h1").className.indexOf("initpv") > -1) return;
        window.document.querySelector("#artiheader h1").classList.add("initpv");
        GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/article/" + id, window.document.querySelector("#artiheader h1").textContent)
      }
    });
  }, [])
  return (
    <section className="article_sec">
      <div id="waves" style={{ width: "100%", height: "100%", position: "absolute" }}></div>
      <div id="waves2" style={{ width: "100%", height: "100%", position: "absolute" }}></div>
      <div id="waves3" style={{ width: "100%", height: "100%", position: "absolute" }}></div>
      <div className="a_title_wrapper">
        <div className="a_title">
          <div className="suitcase"></div>
          <div className="title_text">מה שכדאי לדעת</div>
        </div>
      </div>
      <div style={{ width: "100px", height: "100px" }}></div>
      <div className="vin_wrapper">
        <VignetteArticle articleId={id} />
      </div>
      <div id="spot" data-spotim-module="conversation" data-post-id={id}></div>
      <div style={{ width: "100px", height: "100px" }}></div>
      <Footer isAbsolute={true} />
    </section>
  )
}
